module.exports = __webpack_public_path__ + "assets/icons/ic_chevron_left_24px.svg";